<template>
  <div class="b-breadcrumb-page">
    <div class="b-container">
      <div class="b-main">
        <div class="b-readcumb">
          <div class="b-coin"></div>
          <div class="b-home">Route：</div>
          <div class="b-cursor">
            <ul>
              <li>
                <router-link to="/en">Home</router-link>
              </li>
              <li>
                <router-link :to="path">{{name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import $ from "jquery";

export default {
  data () {
    return {
      path: "",
      name: ""
    };
  },
  mounted () {
    this.path = this.$route;

    var map = {};
    map['about'] = "设施简介";
    map['aboutEn'] = "About Us > Overview";
    map['about6En'] = "About Us > Bases";
    map['about3'] = "技术系统";
    map['about5'] = "组织架构";

    map['service6'] = "光谱波谱质谱平台";
    map['service7'] = "新药研发与工艺安全性评价平台";
    map['service7En'] = "Research Support > Core Facilities > Cores > Biotherapy Development Core";
    map['service8'] = "电镜 - 影像中心(平台)";
    map['service8En'] = "Research Support > Core Facilities > Cores > Drug Screening Core";
    map['service9'] = "上海交通大学校级计算平台";
    map['service9En'] = "Research Support > Core Facilities > Cores > High Performance Computing";
    map['service10'] = "诊疗仪器开发平台";
    map['service10En'] = "Research Support > Core Facilities > Cores > Service Platform of Medical Equipment Development";

    map['service0'] = "生物医学制造技术中心";
    map['service0En'] = "Research Support > Technology Centers > Manufacturing Technology Center for Biomedical Devices";
    map['service2'] = "生物医学数据技术中心";
    map['service2En'] = "Research Support > Technology Centers > Center for Biomedical Data Science";
    map['service3'] = "模式动物技术中心";
    map['service3En'] = "Research Support > Technology Centers > Center for Pharmaceutical Innovation";
    map['service'] = "新药创制与材料技术中心";
    map['service4'] = "生物医学影像技术中心";
    map['service4En'] = "Research Support > Technology Centers > Biomedical Imaging Center";

    map['service5En'] = "Research Support > Technology Centers > Model Animal Center";
    map['service13En'] = "Research Support > Core Facilities > Cores > Electron Microscopy & Imaging Unit";
    map['service14En'] = "Research Support > Core Facilities > Cores > Surface & Properties Analysis Unit";
    map['service15En'] = "Research Support > Core Facilities > Cores > The Element Analysis Unit";
    map['service16En'] = "Research Support > Core Facilities > Cores > Spectrometry & Spectroscopy Unit";

    map['service11En'] = "Research Support > Shared Labs";
    map['service12En'] = "Research Support > Core Facilities > Cores > Biomarker and Drug R&D Platform";

    map['kyuser2En'] = "Users > User Guide";

    map['kyuser3En'] = "Users > User Stations";

    map['activityEn'] = "Collaboration & Cooperation > Joint Institutes";
    map['imagesetEn'] = "Collaboration & Cooperation > Research Partners";
    map['cooperationsEn'] = "Collaboration & Communication";
    map['tang'] = "唐仲英楼";

    map['event2En'] = "Research Programs > Open Research Program";
    map['event1En'] = "Research Programs > STAR";
    map['health'] = "上海交通大学大健康计划";

    map['party'] = "党建工作";
    map['party1'] = "主题教育";
    map['party2'] = "特色活动";

    map['pts'] = "公共仪器平台";
    map['zxs'] = "技术服务";

    map['newsEn'] = "News";
    map['noticeEn'] = "Notice";

    map['sciences'] = "科学普及";

    console.log("type: "+this.$route.query.type);

    if(this.$route.query.type == 'news')
      map['detailEn'] = "News > content";
    else if(this.$route.query.type == 'notice')
      map['detailEn'] = "Notice > content";
    else if(this.$route.query.type == 'achievements')
      map['detailEn'] = "Achievements > content";
    else
      map['detailEn'] = "content";

    map['achievementsEn'] = "Technological Breakthroughs";
    map['achievements10En'] = "Highlights";

    if(this.$route.query.id=='pt')
      map['kyuser'] = "公共仪器平台";
    else if(this.$route.query.id=='zx')
      map['kyuser'] = "技术合作";

    this.name = map[this.$route.name];
    console.log(this.name);

  }
};
</script>
<style lang="scss" scoped>
.b-breadcrumb-page {
  border-bottom: 1px solid #ddd;
  .b-readcumb {
    height: 50px;
    line-height: 45px;
    display: flex;
    align-items: center;
    .b-coin {
      width: 15px;
      height: 15px;
      background: url(../../../assets/img/home.png) no-repeat;
      background-size: inherit;
      margin-right: 5px;
      margin-top: 3px;
    }
    .b-home {
      color: #777;
      font-size: 12px;
      font-weight: normal;
      font-family: Avenir, Helvetica, Arial, sans-serif;
      text-decoration: none;
    }
    .b-cursor ul {
      display: flex;
      align-items: center;
      li a {
        color: #777;
        font-size: 12px;
        font-weight: normal;
        font-family: microsoft yahei;
        text-decoration: none;
      }
      > li + li:before {
        content: ">";
        font-family: 宋体;
        color: #555;
        padding: 0 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/en/index.vue